<template>
  <div class="push-widget">
    <div class="push-widget__close" @click="$emit('close')"></div>
    <img :src="require(`@/assets/images/demo/push-${path}.jpg`)" draggable="false" alt="" />
  </div>
</template>

<script>
export default {
  computed: {
    path() {
      return this.$i18n.locale === "ru" ? "ru" : "en";
    },
  },
};
</script>

<style lang="scss" scoped>
.push-widget {
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  background: #fff;
  padding: 12px;
  border-radius: 15px;
  z-index: 99999;
  font-family: "Roboto";

  img {
    width: 301px;
  }

  &__close {
    position: absolute;
    top: 23px;
    right: 19px;
    width: 25px;
    height: 25px;
    cursor: pointer;
    opacity: 0.2;
  }
}
</style>
